<label class="drawer-label" [for]="labelID">{{ label }}</label>
<div class="configurator-field" [ngClass]="{ group: !isEmptyString(suffix) }">
  <input type="text" [id]="labelID" [value]="initialValue" />
  <span *ngIf="!isEmptyString(suffix)" class="suffix">{{ suffix }}</span>
</div>
